var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2586 5.37508L11.3086 2.51675C10.5003 2.05008 9.50026 2.05008 8.68359 2.51675L3.74193 5.37508C2.93359 5.84175 2.43359 6.70842 2.43359 7.65008V13.3501C2.43359 14.2834 2.93359 15.1501 3.74193 15.6251L8.69193 18.4834C9.50026 18.9501 10.5003 18.9501 11.3169 18.4834L16.2669 15.6251C17.0753 15.1584 17.5753 14.2917 17.5753 13.3501V7.65008C17.5669 6.70842 17.0669 5.85008 16.2586 5.37508ZM10.0003 6.61675C11.0753 6.61675 11.9419 7.48342 11.9419 8.55841C11.9419 9.63342 11.0753 10.5001 10.0003 10.5001C8.92526 10.5001 8.05859 9.63342 8.05859 8.55841C8.05859 7.49175 8.92526 6.61675 10.0003 6.61675ZM12.2336 14.3834H7.76693C7.09193 14.3834 6.70026 13.6334 7.07526 13.0751C7.64193 12.2334 8.74193 11.6667 10.0003 11.6667C11.2586 11.6667 12.3586 12.2334 12.9253 13.0751C13.3003 13.6251 12.9003 14.3834 12.2336 14.3834Z",
    fill: "#444656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.8ff573f87396a9995d6c54f3f8fe60ce.svg";
export { ForwardRef as ReactComponent };